/** react-query key for the saved-views list. Shared with the command
 *  palette, which runs the same query so the two share one cache entry. */
export const SAVED_VIEWS_QUERY_KEY = 'saved-views'
